import { render, staticRenderFns } from "./ManageCertificateTypesSidebar.vue?vue&type=template&id=1f86d0b8&scoped=true"
import script from "./ManageCertificateTypesSidebar.vue?vue&type=script&lang=js"
export * from "./ManageCertificateTypesSidebar.vue?vue&type=script&lang=js"
import style0 from "./ManageCertificateTypesSidebar.vue?vue&type=style&index=0&id=1f86d0b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f86d0b8",
  null
  
)

export default component.exports